type ContractPointVolume = {
  point_id: number;
  volume: number;
};

export enum ContractType {
  FIRM = 'Firm',
  IT = 'IT',
  SUPER = 'Super',
}

export enum ContractTypeNumber {
  FIRM = 1,
  IT = 2,
  SUPER = 3,
}

export type Contract = {
  id: number | string;
  name: string;
  description: string;
  start_date: string;
  end_date: string;
  created_at: string;
  updated_at: string;
  organization: number;
  organization_name: string;
  owner: string;
  k_id: string;
  type: string;
  rate_schedule_type: string;
  fuel_rate_schedule: number | null;
  fuel_rate_schedule_name: string | null;
  commodity_rate_schedule: number | null;
  commodity_rate_schedule_name: string | null;
  max_daily_quantity: number;
  is_segmentable?: boolean;
  tsp: number | string;
  tsp_name: string;
  receipt_points: number[];
  receipt_volumes: ContractPointVolume[];
  delivery_points: number[];
  delivery_volumes: ContractPointVolume[];
  receipt_zones: string[];
  delivery_zones: string[];
  use_in_scenarios: boolean;
  component_key?: string;
  edge_classification: [
    { type: 'IN_PATH'; edge_ids: number[] },
    { type: 'OUT_OF_PATH'; edge_ids: number[] },
    { type: 'IT'; edge_ids: number[] },
  ];
};
